import React from 'react';
import { Center } from '@fiverr-private/layout_components';
import { Carousel, Arrows, Track, Slide } from '@fiverr-private/carousel';
import { Typography, Link } from '@fiverr-private/typography';
import { translate } from '@fiverr-private/i18n-react';
import { testimonials } from '../../consts';
import { useVerticalFlowEvents } from '../../hooks/useVerticalFlowEvents';

export const TestimonialsSection = () => {
    const { impressionRef, reportClickEvent } = useVerticalFlowEvents('Testimonials');

    return (
        <Center ref={impressionRef} marginX={{ md: '12', default: '4' }} onClick={reportClickEvent}>
            <Carousel breakpoints={{ default: 1 }} isInfinite>
                <Arrows />
                <Track>
                    {testimonials.map((testimonial, index) => (
                        <Slide key={index}>
                            <Center
                                direction="column"
                                textAlign="center"
                                gap="4"
                                height={{ default: '254px', sm: '436px' }}
                                alignSelf="center"
                            >
                                <Typography
                                    overflowWrap="anywhere"
                                    width="85%"
                                    size={{ default: 'b_md', sm: 'h_xxl' }}
                                    fontFamily="domaine"
                                    color="green_1000"
                                >
                                    {`"${translate(testimonial.textKey)}"`}
                                </Typography>
                                <Center direction="row" gap="1">
                                    <Link fontSize="b_sm" href={testimonial.link} fontWeight="bold" decoration="none">
                                        {testimonial.author}
                                    </Link>
                                    <Typography size="b_sm">{`| ${testimonial.authorRole}`}</Typography>
                                </Center>
                            </Center>
                        </Slide>
                    ))}
                </Track>
            </Carousel>
        </Center>
    );
};
